export default {
	add(data, cb, ecb) {
		this.http
			.post('/tag/add', data)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	remove({ target_id, target_type, tag_id }, cb, ecb) {
		this.http
			.get('/tag/remove', {
				params: { target_id, target_type, tag_id }
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getTags({ id, type }, cb, ecb) {
		this.http
			.get('/tag/search', {
				params: { target_id: id, target_type: type }
			})
			.then((r) => cb && cb(r?.objects || []))
			.catch((e) => ecb && ecb(e))
	},
	getGroups({ id, type } = {}, cb, ecb) {
		this.http
			.get('/tag/getGroups', {
				params: { id, type }
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	search(params, cb, ecb) {
		this.http
			.get('/tag/search', { params })
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	searchGroup(params, cb, ecb) {
		this.http
			.get('/tag/searchGroup', { params })
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	}
}
